import {useState} from 'react' 
import AuthComponent from '../components/AuthComponent'
import {CustomAxiosError,DataProps} from '../utils/types'
import axios from 'axios'
import { fullname, id, role, tokenName, email, subscriptionStatus, subscriptionExpiry } from '../utils/data'
import { LoginUrl } from '../utils/network'
import {Modal} from 'antd' 
import {useNavigate, useLocation} from 'react-router-dom'
import { useAuth } from '../utils/hooks'
import AuthLayout from '../components/AuthLayout'

interface LoginDataProps{
    data:{
        access:string,
        id:number,
        role:string,
        fullname:string,

    }
}

function Login() {
    
    const [loading,setLoading]= useState(false) 
    const [errorModal, setErrorModal] = useState<{
        visible: boolean;
        message: string;
    }>({
        visible: false,
        message: ''
    });
    const history=useNavigate()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const redirectUrl = queryParams.get('redirect') || "/"

    useAuth({
        successCallBack:()=>{
            history(redirectUrl)
        }
    })

    const onSubmit =async (values:DataProps)=>{
        setLoading(true)
        try {
            const response = await axios.post(LoginUrl, values);
            
            if(response && response.data){
                localStorage.setItem(tokenName, response.data.access);
                if (response.data.id !== undefined) localStorage.setItem(id, response.data.id.toString());
                if (response.data.role) localStorage.setItem(role, response.data.role);
                if (response.data.fullname) localStorage.setItem(fullname, response.data.fullname);
                if (response.data.email) localStorage.setItem(email, response.data.email);
                
                const subStatus = response.data.subscription_status || response.data.user?.subscription_status || 'inactive';
                localStorage.setItem(subscriptionStatus, subStatus);

                const subExpiry = response.data.subscription_expiry_date || response.data.expiry_date || response.data.user?.subscription_expiry_date || response.data.user?.expiry_date || '';
                if (subExpiry) {
                    localStorage.setItem(subscriptionExpiry, subExpiry);
                }

                history(redirectUrl);
            }
        } catch (e: any) {
            console.log('Login error caught:', e);
            console.log('Error response:', e.response?.data);
            
            const errorMessage = e.response?.data?.error || "An error occurred during login";
            console.log('Showing modal with message:', errorMessage);
            
            // Show error modal
            setErrorModal({
                visible: true,
                message: errorMessage
            });
        }
        setLoading(false)
    }
    return (
        <AuthLayout>
            <AuthComponent 
                onSubmit={onSubmit} 
                loading={loading} 
                errorMsg={errorModal.visible ? errorModal.message : null}
                onErrorClose={() => setErrorModal({ visible: false, message: '' })}
            />
        </AuthLayout>
    )
}

export default Login